<template>

	<div>
		<Header :utilityNav="header.utilityNav" :siteNavigation="header.siteNavigation"></Header>
        <div class="container">
            <Breadcrumbs v-if="breadcrumbs" :breadcrumbs="breadcrumbs"></Breadcrumbs>
            <div class="how-to-steps">
                <StepIndicator :key="1" :currentStep="1" :totalSteps="3" :contactCards=contactCards></StepIndicator>
                <StepIndicator :key="2" :currentStep="2" :totalSteps="3" :contactCards=contactCards></StepIndicator>
                <StepIndicator :key="3" :currentStep="3" :totalSteps="3" :contactCards=contactCards></StepIndicator>
            </div>
        </div>
		<Footer :contact="footer.contact" :nav="footer.nav" :social="footer.social" :legal="footer.legal"></Footer>
	</div>
	
</template>

<script>
	
    import Header from '../components/Header/Header.vue';
    import Breadcrumbs from '../components/Global/Breadcrumbs.vue';
    import StepIndicator from '../components/Global/StepIndicator.vue';
	import Footer from '../components/Footer/Footer.vue';
	import axios from 'axios';
	
	export default {
		name: 'StepIndicatorDemo',
		
		components: {
            Header,
            Breadcrumbs,
            StepIndicator,
			Footer
		},
		
		data() {
			return {
				header: {
					utilityNav: {},
					siteNavigation: {}
                },
                breadcrumbs: [],
                contactCards: [],
				stepIndicators: 6,
				footer: {
					contact: {},
					nav: [],
					social: [],
					legal: ""
				}
			}
		},
		
		methods: {
		
		},
		
		mounted: function() {
			
			/* eslint-disable no-console */
			let self = this;
            let endpointID = this.$el.parentElement.getAttribute('data-endpoint-id');
            if (endpointID) {

                let endpoint = location.protocol + '//' + window.location.host + this.$projectRoot + '/SampleData/' + endpointID + '.json';

                axios.get(endpoint).then(function (response) {
                    self.breadcrumbs = response.data.breadcrumbs;
                    self.contactCards = response.data.cards;
                    console.log(response.data.cards)
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
			
			let header = location.protocol + '//' + window.location.host + this.$projectRoot + '/SampleData/HeaderData.json';
			axios.get(header).then(function(response) {
				
				self.header.utilityNav = response.data.utilityNav;
                self.header.siteNavigation = response.data.siteNavigation;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let footer = location.protocol + '//' + window.location.host + this.$projectRoot + '/SampleData/FooterData.json';
			axios.get(footer).then(function(response) {
				
				self.footer.contact = response.data.contact;
				self.footer.nav = response.data.nav;
				self.footer.social = response.data.social;
				self.footer.legal = response.data.legal;
			})
			.catch(function (error) {
				console.log(error);
            });

		}
	}
	
</script>